import { render, staticRenderFns } from "./OwnershipAutocomplete.vue?vue&type=template&id=b04841c0"
import script from "./OwnershipAutocomplete.vue?vue&type=script&lang=js"
export * from "./OwnershipAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports